module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_02-52c6aafd815c9f67f13ccdffc5ce5b37.webp";